module.exports = __webpack_public_path__ + "img/logo_dark.99951324.png";